<template>
  <div class="access-denied">
    <h1>Access Denied</h1>
    <p>You do not have permission to view this page.</p>
    <p>Please contact the administrator if you believe this is an error.</p>
  </div>
</template>

<script>
export default {
  name: 'AccessDenied'
};
</script>

<style scoped>
.access-denied {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100vh;
}

h1 {
  font-size: 2rem;
  color: red;
}

p {
  font-size: 1rem;
  color: #555;
}
</style>
